import React from "react";
import styled from "styled-components";
import colors from "../../../utils/colors";
import sectionThemes from "../../../ui/sectionThemes";
import BaseContainer from "../../../ui/BaseContainer";

const bgRed = `${process.env.PUBLIC_URL}/img/bg-img-red.png`;

const StyledSection = styled.section`
  width: 100%;
  padding: 0 2rem;
  box-sizing: border-box;

  ${props =>
    props.theme &&
    props.theme === sectionThemes.CMORE &&
    `
    > div {
      > a, > header {
		    color: ${colors.WHITE};
      }
    }
    background-image: url(${bgRed});
    background-repeat: repeat;
    background-position: 50% 0;
    background-size: auto;
	`} ${props =>
    props.theme &&
    props.theme === sectionThemes.LIGHT &&
    `
		background: ${colors.WHITE};
	`};
`;

const ContentWrapper = BaseContainer.extend`
  margin: 0 auto;
  padding: 2rem 0;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-between;

  &.tight {
    padding: 0;
  }

  > header {
    width: 100%;
    line-height: 2rem;
    margin-bottom: 1.5rem;
  }

  > a {
    color: ${colors.WHITE};
  }
`;

const ContentSection = props => {
  const { title, tight, children, ...rest } = props;
  return (
    <StyledSection {...rest}>
      <ContentWrapper className={tight && "tight"}>
        {title && (
          <header>
            <h2>{title}</h2>
          </header>
        )}
        {children}
      </ContentWrapper>
    </StyledSection>
  );
};

export default ContentSection;



// WEBPACK FOOTER //
// ./src/modules/pages/components/ContentSection.js